import React from 'react';

import { isNull } from '../is';

import { useResizeObserver } from './useResizeObserver';

export const useOffsetWidth = (containerRef: React.RefObject<HTMLElement>) => {
  const [width, setWidth] = React.useState(0);

  const calculateOffsetWidth = React.useCallback(() => {
    !isNull(containerRef.current) && setWidth(containerRef.current.offsetWidth);
  }, []);

  useResizeObserver(containerRef, calculateOffsetWidth);

  return width;
};
